const messages = {
  required: 'Campo obrigatório',
  numeric: 'Somente números',
  integer: 'Somente números',
  decimal: 'Campo decimal',
  email: 'Campo tipo e-mail',
  minLength: 'O tamanho mínimo é de :min caracteres',
  maxLength: 'O tamanho maximo é de :max caracteres',
  minValue: 'O valor mínimo deve ser :min',
  maxValue: 'O valor maximo deve ser :max',
  between: 'Valor deve ser entre :min e :max',
  alpha: 'Campo aceita somente letras sem espaços',
  alphaSpace: 'Campo aceita somente letras',
  alphaNumSpace: 'Campo aceita somente letras e números',
  alphaNumSpaceEnter: 'Campo aceita somente letras, números e os caracteres: ° º ª . , : ; ` ´ \' " * ! ? < > | _ ( ) - + = / \ [ ] { } # $ % & ',
  words: 'Campo só pode conter palavras.',
  lessThen: 'O valor deve ser menor do que :data',
  sameAs: 'O valor deve ser igual ao do campo :eq',
  validaCnpj: 'CNPJ inválido',
  validaCpf: 'CPF inválido',
  maiorOuIgual: 'A data deve ser igual ou posterior a data atual',
  isValidDate: 'A data é inválida',
  isValid: 'Valor inválido',
  isFileSizeValid: 'O arquivo tem tamanho maior que o permitido',
  isFileExtensionValid: 'Há arquivos com extensões não permitidas',
  isAfterToday: 'A data deve ser posterior a data de hoje',
  limitArraySize: 'Quantidade de items é maior que o permitido',
  before: 'A data deve ser anterior a :data',
};

export default messages;
